import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center justify-center select-none text-lg font-medium leading-tight text-center text-white w-24 h-16 rounded-lg bg-no-repeat bg-center bg-cover float-left", { 'opacity-25': _ctx.text }]),
    style: _normalizeStyle(_ctx.imageUrl ? 'background-image: url(' + _ctx.imageUrl + ')' : '')
  }, _toDisplayString(_ctx.text), 7))
}